import { render, staticRenderFns } from "./FormatPageEditorMenuContainer.vue?vue&type=template&id=e5e877c8&scoped=true&"
import script from "./FormatPageEditorMenuContainer.vue?vue&type=script&lang=ts&"
export * from "./FormatPageEditorMenuContainer.vue?vue&type=script&lang=ts&"
import style0 from "./FormatPageEditorMenuContainer.vue?vue&type=style&index=0&id=e5e877c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5e877c8",
  null
  
)

export default component.exports